import { type PublicProfileDto } from '@spin/shared';
import { useEffect, useState } from 'react';
import { http } from '../api/http';
import { Avatar } from '../components/common';
import { PriceHeart } from '../components/icons';
import { useT } from '../i18n';
import { useRoom } from '../store/room';
import { useUi } from '../store/ui';
import { tg } from '../tg/bridge';

/** "Courting": somebody started admiring me (the reference's popup with "Alright"). */
export function CourtingDialog({ userId, name, price }: { userId: string; name: string; price: number }) {
  const t = useT();
  const close = useUi.getState().closeDialog;
  const seated = useRoom((s) => s.room?.seats.find((x) => x?.userId === userId)?.photoUrl);
  const [photo, setPhoto] = useState<string | null>(null);
  useEffect(() => tg.backButton.show(close), [close]);
  useEffect(() => {
    if (seated !== undefined || !userId) return;
    http
      .get<PublicProfileDto>(`/users/${userId}`)
      .then((p) => setPhoto(p.photoUrl))
      .catch(() => undefined);
  }, [seated, userId]);

  return (
    <div className="dialog-layer centered">
      <div className="dialog courting" role="dialog" data-testid="courting">
        <div className="dialog-title">{t('courting.title')}</div>
        <div className="dialog-body">
          <div className="courting-row">
            <span className="courting-who">
              <span className="courting-photo">
                <Avatar name={name} photoUrl={seated ?? photo} size="100%" />
              </span>
              <small className="ellipsis">{name}</small>
            </span>
            <p>
              {t('courting.text', { name })} <PriceHeart /> <b>{price}</b>
            </p>
          </div>
          <button className="btn btn-green courting-ok" onClick={close} data-testid="courting-ok">
            {t('courting.ok')}
          </button>
        </div>
      </div>
    </div>
  );
}
